<template>
    <v-card v-bind="$attrs" flat color="transparent" v-on="$listeners">
        <v-textarea
            v-model="strSerials"
            data-cy="input-serial-field"
            label="Input Serial Numbers (one per line, max 20 lines)"
            class="serial-validator pr-4"
            outlined
            clearable
            rows="3"
            v-bind="$attrs"
            v-on="$listeners"
            @click:clear="verifySerials"
            @input="verifySerials"
        >
            <template v-slot:append-outer>
                <v-card v-if="callingApi" flat width="24" height="24" color="transparent">
                    <v-progress-circular width="2" size="20" color="secondary" indeterminate></v-progress-circular>
                </v-card>
                <v-card v-else width="24" height="24" color="transparent" flat>
                    <v-card
                        v-if="serialNotFound"
                        flat
                        data-cy="serial-not-found-icon"
                        color="transparent"
                        width="24"
                        height="24"
                    >
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="error" dark v-bind="attrs" v-on="on">
                                    {{ mdiAlertCircleOutline }}
                                </v-icon>
                            </template>
                            <span>Serial Not Found</span>
                        </v-tooltip>
                    </v-card>
                    <v-card
                        v-else-if="!serialIsValid && serialValues && serialValues.length >= 10"
                        data-cy="serial-not-valid-icon"
                        flat
                        color="transparent"
                        width="24"
                        height="24"
                    >
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="red" dark v-bind="attrs" v-on="on">
                                    {{ mdiCheckboxMarkedCircleOutline }}
                                </v-icon>
                            </template>
                            <span>Serial not valid for new RMA</span>
                        </v-tooltip>
                    </v-card>
                    <v-card
                        v-else-if="serialIsValid"
                        data-cy="serial-valid-icon"
                        flat
                        color="transparent"
                        width="24"
                        height="24"
                    >
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="green" dark v-bind="attrs" v-on="on">
                                    {{ mdiCheckboxMarkedCircleOutline }}
                                </v-icon>
                            </template>
                            <span>Serial valid for new RMA!</span>
                        </v-tooltip>
                    </v-card>
                    <v-card v-else data-cy="serial-not-input-icon" flat color="transparent" width="24" height="24" />
                </v-card>
            </template>
        </v-textarea>
    </v-card>
</template>
<script>
import { verifySerialForRma } from '@/api'
import { mdiAlertCircleOutline, mdiCheckboxMarkedCircleOutline, mdiCancel } from '@mdi/js'
export default {
    name: `ValidateWarranty`,

    props: {
        outsideSerials: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            callingApi: false,
            mdiCheckboxMarkedCircleOutline,
            mdiAlertCircleOutline,
            mdiCancel,
            strSerials: '',
            serialValues: [],
            serialData: {}
        }
    },

    computed: {
        serialNotFound() {
            return !!(
                this.serialValues &&
                this.serialValues.length &&
                !Object.keys(this.serialData).includes(`iw`) &&
                !Object.keys(this.serialData).includes(`rmaExists`)
            )
        },
        serialIsValid() {
            return (
                (!!(this.serialData.serial && !this.serialData.rmaExists) || !!this.serialData.allowOow) &&
                !this.serialData.isEOS &&
                this.serialData.model !== 'EX80'
            )
        }
    },

    mounted() {
        if (this.outsideSerials) {
            this.strSerials = this.outsideSerials
            this.serialValues = this.strSerials ? this.strSerials.split(/\r?\n/).map((s) => s.trim()) : []
        }
        this.verifySerials()
    },

    methods: {
        limitLines() {
            const lines = this.strSerials.split(/\r?\n/)

            if (lines.length > 20) {
                this.strSerials = lines.slice(0, 20).join('\n')
            }
        },
        async verifySerials() {
            if (!this.strSerials) {
                this.serialValues = []
                this.serialData = {}
                this.$emit(`isValid`, this.serialIsValid)
                this.$emit(`serialData`, this.serialData)
                return
            }
            this.limitLines()
            this.serialValues = this.strSerials
                .split(/\r?\n/)
                .map((s) => s.trim())
                .filter((s) => s.length > 0)
            this.serialData = {}
            this.callingApi = true
            let model = ''
            for (const serial of this.serialValues) {
                if (serial && serial.length >= 9) {
                    try {
                        const { data } = await verifySerialForRma({
                            serial: serial.toUpperCase().trim()
                        })
                        if (data.constructor.name !== `Object`) {
                            // show error
                            this.serialData = { serial: serial, errorMessage: `Unable to find serial ${serial}` }
                            break
                        }
                        // only IW
                        if (!data.iw) {
                            this.serialData = {
                                serial: serial,
                                errorMessage: `Can not create Multiple RMA for OOW ${serial}`
                            }
                            break
                        }
                        // only Video is allowed
                        if (data.productType !== 'VERETOS' || data.allowedRepairType !== 'GVS_ADVANCE_EXCHANGE') {
                            this.serialData = {
                                serial: serial,
                                errorMessage: `Non-video device ${serial} can NOT create RMA by multiple serials `
                            }
                            break
                        }
                        if (!model) {
                            model = data.model
                        } else if (model !== data.model) {
                            this.serialData = {
                                serial: serial,
                                errorMessage: `All serials must be of the same model. Mismatched model found at ${serial}`
                            }
                            break
                        }

                        this.serialData = data
                    } catch (error) {
                        console.log(error)
                        this.serialData = { serial: serial, errorMessage: `Error to find serial ${serial}` }
                        break
                    }
                }
            }
            this.callingApi = false
            if (!this.serialData.errorMessage) {
                // add serials info
                this.serialData.serials = this.serialValues
            }
            this.$emit(`isValid`, this.serialIsValid)
            this.$emit(`serialData`, this.serialData)
        }
    }
}
</script>
<style lang="scss">
.serial-validator {
    input {
        text-transform: uppercase;
    }
}
</style>
